import React, { FC, ReactNode } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import cx from 'classnames';

import { Col, Container, Link, Row } from '@nord/ui';

import nordLayerDarkLogo from '../../assets/img/nord-layer-dark-logo.svg';
import BackButton from '../../atoms/BackButton';
import BrowserSupportNotification from '../../atoms/BrowserSupportNotification';
import SVG from '../../atoms/SVG';
import useBrowserOutdated from '../../hooks/useBrowserOutdated';
import './index.scss';

export interface IPublicContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  withHeader?: boolean;
  withBackButton?: boolean;
  logo?: string; // TODO: DEPRECATED
  logoComponent?: ReactNode;
  headerProps?: IHeaderProps;
  showOutdatedBrowser?: boolean;
}

interface IHeaderProps {
  shadow?: boolean;
  narrow?: boolean;
}

const PublicContainer: FC<IPublicContainerProps> = ({
  withHeader = true,
  withBackButton = false,
  logo,
  logoComponent,
  headerProps: { shadow, narrow } = { shadow: false, narrow: false },
  children,
  showOutdatedBrowser = false,
}) => {
  const isBrowserOutdated = useBrowserOutdated();
  const shouldDisplayBrowser = isBrowserOutdated && showOutdatedBrowser;

  return (
    <main className="PublicContainer flex flex-col flex-1 bg-white">
      {shouldDisplayBrowser && <BrowserSupportNotification />}
      {!!withHeader && (
        <div
          className={cx(
            'py-4 md:py-0 absolute z-1 top-0 left-0 flex justify-center w-full',
            shadow ? 'shadow-1' : 'shadow-1 md:shadow-none',
            shouldDisplayBrowser && 'browserNotificationSpacing'
          )}
        >
          <Container fluid={!narrow}>
            <div className="lg:my-4 my-4">
              <Row justify="between" align="center">
                <Col lg={6} sm={8} xs={9} className="flex flex-no-wrap items-center justify-start">
                  {withBackButton && <BackButton colorClassName="text-black" buttonText="" />}
                  <Link component={RouterLink} to="/" colorClassName="text-black">
                    {logoComponent || (
                      <SVG
                        src={logo || nordLayerDarkLogo}
                        title="NordLayer: Business VPN"
                        noDefaultSize={!!logo}
                        className={cx('text-black', !narrow && 'md:ml-5')}
                        width={143}
                        height={30}
                      />
                    )}
                  </Link>
                </Col>
                {/* TODO: When HELP will be coded add the link to it. Now it only redirects so comment out */}
                {/* <Col lg={6} sm={4} xs={3} className="flex flex-no-wrap items-end justify-end">
              <Link
                component={RouterLink}
                className="md:mr-5"
                colorClassName="text-grey-dark"
                to=""
              >
                <TextWithIcon
                  icon="images/global/icons/16/support.svg"
                  variant="caption"
                  title="Help"
                  className="font-bold"
                >
                  Help
                </TextWithIcon>
              </Link>
            </Col> */}
              </Row>
            </div>
          </Container>
        </div>
      )}
      {children}
    </main>
  );
};

export default PublicContainer;
